<template>
  <v-card
    class="card--destiny primary-shadow"
    max-width="497"
    @click="setDestination"
  >
    <v-img
      class="white--text align-end"
      aspect-ratio="1.7"
      max-height="272"
      :src="`/storage/${destination.results_thumbnail_image}`"
    >
    </v-img>
    <v-card-text class="text--primary">
      <h3 class="heading-3 color-black">{{ destination.name }}</h3>
    </v-card-text>
    <v-card-actions class="items-center justify-between">
      <p class="v-card__price color-black m-0 font-black">
        {{ destination.pivot.base_price | currency }}
      </p>
      <v-btn
        text
        color="secondary"
      >
        {{ $t('shared.start_your_trip') }}
        <v-icon right>mdi-chevron-right</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { SET_GIFTS_STATE } from "../../store/gifts/mutation-types";

export default {
    props: {
        destination: {
            type: Object,
            required: true
        }
    },
    methods: {
      setDestination() {
        this.$store.commit(SET_GIFTS_STATE, { prop: 'destination_id', value: this.destination.id });

        this.$router.push(`/regala/${this.destination.slug}`);
      }
    }
};
</script>
